module.exports = __webpack_public_path__ + "static/media/Martial Arts Boy.9579aa31.jpg";